import axios, { AxiosRequestConfig } from 'axios';

export default

    axios.create({
        baseURL: "http://reactify.theironnetwork.org/data/",
        headers: {
          common: {
          }
        },
        transformRequest: [(data, headers) => {
          delete headers.common
          return data
      }]
    });
    axios.defaults.headers.common = {};